<template>
  <div class="article-floor">
    <div class="article-floor-text">分享文章：</div>
    <div>
      <img
        class="article-floor-icon hover-black"
        @click.prevent="goWb"
        src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210621150648242-web_icon_wb@2x.png"
        alt=""
      />
    </div>
    <hover-qrcode :src="qrcode">
      <img
        class="article-floor-icon hover-black"
        src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210621150648302-web_icon_wx@2x.png"
        alt=""
      />
    </hover-qrcode>
    <img
      class="article-floor-icon hover-black"
      @click.prevent="copy"
      src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630165232821-web_icon_lj@2x.png"
    />
  </div>
</template>

<script>
import HoverQrcode from "@components/HoverQrcode";
import { getToast } from "@/components/Popup";
var QRCode = require("qrcode");
export default {
  name: "ArticleCode",
  components: {
    HoverQrcode,
  },
  props: {
    title: {
      type: String,
      default:
        "HYCAN 合创以“合创”为理念，构筑一个开发、友好、独立的创·享平台，为用户提供创·享出行生活新生态。",
    },
    query: {
      type: String,
      default: ".news-detail-content img",
    },
    pageUrl: {
      type: String,
      default: window.location.href,
    },
  },
  data() {
    return {
      qrcode: window.location.href,
    };
  },
  computed: {},
  created() {},
  mounted() {
    QRCode.toDataURL(window.location.href, (err, url) => {
      console.log(err, url);
      if (url) {
        this.qrcode = url;
      }
    });
  },
  methods: {
    goWb() {
      let shareImgs = this.getImgUrl();
      let url = window.location.href;
      window.open(
        "http://service.weibo.com/share/share.php?url=" +
          url +
          "&appkey=179995858&language=zh_cn&title=" +
          this.title +
          "&source=&sourceUrl=&ralateUid=6563374966&message=&uids=&pic=" +
          shareImgs +
          "&searchPic=true&content="
      );
    },
    copy() {
      let text = this.pageUrl;
      if (typeof document.execCommand !== "function") {
        alert("复制失败，请长按复制");
        return;
      }
      var dom = document.createElement("textarea");
      dom.value = text;
      dom.setAttribute("style", "display: block;width: 1px;height: 1px;");
      dom.setAttribute("readonly", "readonly");
      document.body.appendChild(dom);
      dom.select();
      var result = document.execCommand("copy");
      document.body.removeChild(dom);
      if (result) {
        getToast().open({
          text: "已复制到剪贴版",
        });
        return;
      }
      if (typeof document.createRange !== "function") {
        getToast().open({
          text: "复制失败，请手动到地址栏复制！",
        });
        return;
      }
      var range = document.createRange();
      var div = document.createElement("div");
      div.innerHTML = text;
      div.setAttribute("style", "height: 1px;fontSize: 1px;overflow: hidden;");
      div.setAttribute("readonly", "readonly");
      document.body.appendChild(div);
      range.selectNode(div);
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        selection.removeAllRanges();
      }
      selection.addRange(range);
      if (document.execCommand("copy")) {
        getToast().open({
          text: "已复制到剪贴版",
        });
      }
    },
    getImgUrl() {
      let imgs = document.querySelectorAll(this.query);
      return [...imgs].map((v) => v.attributes.src.value).join("||");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@style/base";
.article-floor {
  margin-top: 30px;
  display: flex;
  align-items: center;
  .article-floor-text {
    margin-right: -10px;
  }
  .article-floor-icon {
    width: 40px;
    height: 40px;
    display: block;
  }
  & > img,
  & > div:not(.article-floor-text) {
    cursor: pointer;
    margin-left: 20px;
  }
}
</style>
